import { Tabs } from 'tailwindcss-stimulus-components'

// Extended Tabs controller with sliding indicator animation
export default class extends Tabs {
  connect () {
    super.connect()
    // Set CSS variable for total number of tabs (used for sliding indicator width)
    this.element.style.setProperty('--total-items', this.tabTargets.length)
  }

  indexValueChanged () {
    super.indexValueChanged()
    // Update CSS variable for active tab index (used for sliding indicator position)
    this.element.style.setProperty('--active-item', this.indexValue)
  }
}
